module.exports = __webpack_public_path__ + "static/img/znsj_p3.c5af924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/znsj_p3.png
// module id = Wvac
// module chunks = 19